import { Pipe, PipeTransform } from '@angular/core';
import { toJewishDate, toHebrewJewishDate } from "jewish-date";

@Pipe({
    name: 'hebrewMonth'
})
  export class HebrewMonthPipe implements PipeTransform {
    transform(value: any, ...args: any[]): any {
        let date = new Date(value);
        let jewishDate = toJewishDate(date);
        let jewishDateInHebrew = toHebrewJewishDate(jewishDate);
        return jewishDateInHebrew.monthName + ' ' + jewishDateInHebrew.year;
    }
}